module.exports = __webpack_public_path__ + "img/supermercado.feb4b6f9.png";